import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { PrimaryButton, toast } from '@systemeio/ui';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { exportTransactionCsv, exportTransactionPdf, exportTransactionXml } from 'modules/payment/transactions/api/transactions-api';
import { ExportTransactionsCsvColumnsEnum, ExportTransactionsCsvDataInterface, exportTransactionsCsvLocoKeys, ExportTransactionsDataInterface } from 'modules/payment/transactions/types/export-interface';
import { TransactionFilterInterface } from 'modules/payment/transactions/types/transaction-filter-interface';
import React, { useState } from 'react';
import CsvExportModal, { CsvExportColumnInterface, CsvExportData } from 'shared/components/csv-export-modal';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { ListingSelectType } from 'shared/hooks/use-listing-select';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ExportFetchingInterface {
  pdf: boolean;
  csv: boolean;
  xml: boolean;
}
interface ExportTransactionsProps {
  filter: TransactionFilterInterface;
  getListingSelect: ListingSelectType;
}
const ExportTransactions = t0 => {
  const $ = _c(29);
  const {
    filter,
    getListingSelect
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const xmlImportFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.XmlImport);
  const {
    renderListingSelect,
    closeMenu,
    selectedAll,
    selectedIds,
    exceptionIds
  } = getListingSelect(t("dashboard.transactions.transactions_selected"));
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      pdf: false,
      csv: false,
      xml: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [isFetching, setIsFetching] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.post
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t2);
  const [isCsvModalShown, setIsCsvModalShown] = useState(false);
  const exportData = {
    transactionIds: selectedAll ? Array.from(exceptionIds) : Array.from(selectedIds),
    allChecked: selectedAll,
    filter
  };
  const handleExportPdf = async () => {
    ;
    try {
      setIsFetching(_temp);
      await exportTransactionPdf(exportData);
      setIsFetching(_temp2);
      toast.success(t("dashboard.transactions.pdf_response"));
      closeMenu();
    } catch (t3) {
      const e = t3;
      setIsFetching(_temp3);
      throw e;
    }
  };
  const handleExportXml = async () => {
    ;
    try {
      setIsFetching(_temp4);
      await exportTransactionXml(exportData);
      setIsFetching(_temp5);
      toast.success(t("dashboard.transactions.pdf_response"));
      closeMenu();
    } catch (t4) {
      const e_0 = t4;
      setIsFetching(_temp6);
      throw e_0;
    }
  };
  const handleExportCsv = async data => {
    ;
    try {
      setIsFetching(_temp7);
      const csvData = {
        ...exportData,
        exportOptions: {
          exportColumns: data.exportColumns,
          delimiter: data.delimiter
        }
      };
      await exportTransactionCsv(csvData, postFetcher);
      setIsFetching(_temp8);
      toast.success(t("dashboard.transactions.pdf_response"));
      closeMenu();
      setIsCsvModalShown(false);
    } catch (t5) {
      const e_1 = t5;
      setIsFetching(_temp9);
      throw e_1;
    }
  };
  let t6;
  if ($[2] !== t) {
    t6 = () => Object.values(ExportTransactionsCsvColumnsEnum).map(el => ({
      id: el,
      caption: t(exportTransactionsCsvLocoKeys[el])
    }));
    $[2] = t;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const getColumnsData = t6;
  const t7 = isFetching.csv;
  const t8 = isFetching.pdf;
  let t9;
  if ($[4] !== t) {
    t9 = t("global.export_pdf");
    $[4] = t;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== setIsCsvModalShown) {
    t10 = () => setIsCsvModalShown(true);
    $[6] = setIsCsvModalShown;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const t11 = isFetching.pdf || isFetching.csv;
  let t12;
  if ($[8] !== t) {
    t12 = t("global.export_csv");
    $[8] = t;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== t10 || $[11] !== t11 || $[12] !== t12) {
    t13 = <PrimaryButton onClick={t10} disabled={t11}>{t12}</PrimaryButton>;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  const t14 = renderListingSelect(<div className="flex justify-center gap-5">{xmlImportFeatureIsOn && <PrimaryButton disabled={isFetching.xml} isFetching={isFetching.xml} onClick={handleExportXml}>{t("global.export_xml")}</PrimaryButton>}<PrimaryButton disabled={t7} isFetching={t8} onClick={handleExportPdf}>{t9}</PrimaryButton>{t13}</div>);
  let t15;
  if ($[14] !== t) {
    t15 = t("dashboard.transactions.csv_title");
    $[14] = t;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== setIsCsvModalShown) {
    t16 = () => setIsCsvModalShown(false);
    $[16] = setIsCsvModalShown;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== getColumnsData) {
    t17 = getColumnsData();
    $[18] = getColumnsData;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== handleExportCsv || $[21] !== isCsvModalShown || $[22] !== t15 || $[23] !== t16 || $[24] !== t17) {
    t18 = <CsvExportModal className="mb-28 md:mb-0" title={t15} opened={isCsvModalShown} onClose={t16} columns={t17} handleExportCsv={handleExportCsv} />;
    $[20] = handleExportCsv;
    $[21] = isCsvModalShown;
    $[22] = t15;
    $[23] = t16;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t14 || $[27] !== t18) {
    t19 = <>{t14}{t18}</>;
    $[26] = t14;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  return t19;
};
export default ExportTransactions;
function _temp(prev_0) {
  return {
    ...prev_0,
    pdf: true
  };
}
function _temp2(prev_1) {
  return {
    ...prev_1,
    pdf: false
  };
}
function _temp3(prev) {
  return {
    ...prev,
    pdf: false
  };
}
function _temp4(prev_3) {
  return {
    ...prev_3,
    xml: true
  };
}
function _temp5(prev_4) {
  return {
    ...prev_4,
    xml: false
  };
}
function _temp6(prev_2) {
  return {
    ...prev_2,
    xml: false
  };
}
function _temp7(prev_6) {
  return {
    ...prev_6,
    csv: true
  };
}
function _temp8(prev_7) {
  return {
    ...prev_7,
    csv: false
  };
}
function _temp9(prev_5) {
  return {
    ...prev_5,
    csv: false
  };
}